<div class="page-header-container">
  <div class="page-title">
    {{ "requests.clientData.newRequest.Title" | translate }}
  </div>
</div>

<div class="wizard-container" *ngIf="isDataLoaded">
  <button class="btn link-btn btn-back-txt" (click)="redirectFieldSelectionHandler()">
    <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
    <span>{{'requests.clientData.newRequest.Back' | translate}}</span>
  </button>

  <div class="row">
    <span class="col-12 d-flex justify-content-center title">{{
        isPJ ? ("requests.clientData.newRequest.address.TitlePJ" | translate) :
        ("requests.clientData.newRequest.address.TitlePF" | translate)
    }}</span>
  </div>

  <!--home address-->
  <form #form="ngForm">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3">
        <label class="text-field-label">
          {{ "requests.clientData.newRequest.address.Country" | translate }}
          <span class="text-primary fw-bold">*</span>
        </label>
        <input
          kendoTextBox
          class="text-input"
          [(ngModel)]="clientDataRequestSaveModel.addresses[0].country"
          required
          #homeAddressCountry="ngModel"
          name="homeAddressCountry"/>
        <div class="error-info" *ngIf="homeAddressCountry.invalid  && (homeAddressCountry.dirty || form.submitted)">
            <div  *ngIf="homeAddressCountry.errors?.['required']">
                {{'common.validation.required' | translate}}
            </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3">
        <label class="text-field-label">
          {{ "requests.clientData.newRequest.address.State" | translate }}
          <span class="text-primary fw-bold">*</span>
        </label>
        <input
          kendoTextBox
          class="text-input"
          [(ngModel)]="clientDataRequestSaveModel.addresses[0].state"
          required
          #homeAddressState="ngModel"
          name="homeAddressState"/>
          <div class="error-info" *ngIf="homeAddressState.invalid  && (homeAddressState.dirty || form.submitted)">
            <div  *ngIf="homeAddressState.errors?.['required']">
                {{'common.validation.required' | translate}}
            </div>
          </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3">
        <label class="text-field-label"
          >{{ "requests.clientData.newRequest.address.City" | translate }}
          <span class="text-primary fw-bold">*</span>
        </label>
        <input
          kendoTextBox
          class="text-input"
          [(ngModel)]="clientDataRequestSaveModel.addresses[0].city"
          required
          name="homeAddressCity"
          #homeAddressCity="ngModel"/>
          <div class="error-info" *ngIf="homeAddressCity.invalid  && (homeAddressCity.dirty || form.submitted)">
            <div  *ngIf="homeAddressCity.errors?.['required']">
                {{'common.validation.required' | translate}}
            </div>
          </div>
      </div>
      <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3">
        <span class="text-field-label"
          >{{ "requests.clientData.newRequest.address.PostalCode" | translate }}
        </span>
        <input
          kendoTextBox
          class="text-input"
          [(ngModel)]="clientDataRequestSaveModel.addresses[0].postalCode"
          name="homePostalCode"
        />
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-7 col-lg-6 col-xxl-5 col-xxxl-4 mb-3">
        <label class="text-field-label">{{
          "requests.clientData.newRequest.address.Street" | translate
        }}</label>
        <input
          kendoTextBox
          class="text-input"
          [(ngModel)]="clientDataRequestSaveModel.addresses[0].streetName"
          name="homeAddressStreetName"
        />
      </div>
      <div class="col-md-5 col-lg-4 col-xxl-3 col-xxxl-2 mb-3">
        <label class="text-field-label">{{
          "requests.clientData.newRequest.address.StreetNo" | translate
        }}</label>
        <input
          kendoTextBox
          class="text-input"
          [(ngModel)]="clientDataRequestSaveModel.addresses[0].streetNumber"
          name="homeAddressStreetNumber"
        />
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 mb-3">
        <div class="row justify-content-center">
          <div class="col-md-6 col-lg-6 col-xxl-3 col-xxxl-3">
            <label class="text-field-label">{{
              "requests.clientData.newRequest.address.BuildingNo" | translate
            }}</label>
            <input
              kendoTextBox
              class="text-input"
              [(ngModel)]="
                clientDataRequestSaveModel.addresses[0].buildingNumber
              "
              name="homeAddressBuildingNumber"
            />
          </div>
          <div class="col-md-6 col-lg-6 col-xxl-3 col-xxxl-3">
            <label class="text-field-label">{{
              "requests.clientData.newRequest.address.Stair" | translate
            }}</label>
            <input
              kendoTextBox
              class="text-input"
              [(ngModel)]="clientDataRequestSaveModel.addresses[0].stair"
              name="homeAddressStair"
            />
          </div>
          <div class="col-md-6 col-lg-6 col-xxl-3 col-xxxl-3">
            <label class="text-field-label">{{
              "requests.clientData.newRequest.address.Floor" | translate
            }}</label>
            <input
              kendoTextBox
              class="text-input"
              [(ngModel)]="clientDataRequestSaveModel.addresses[0].floor"
              name="homeAddressFloor"
            />
          </div>
          <div class="col-md-6 col-lg-6 col-xxl-3 col-xxxl-3">
            <label class="text-field-label">{{
              "requests.clientData.newRequest.address.Flat" | translate
            }}</label>
            <input
              kendoTextBox
              class="text-input"
              [(ngModel)]="clientDataRequestSaveModel.addresses[0].flatNumber"
              name="homeAddressFlatNumber"
            />
          </div>
        </div>
      </div>
    </div>
    <!--/home address-->

    <div class="row justify-content-center mt-4">
      <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
        <div class="divider-line"></div>
        <div role="button"
          class="mailing-text d-flex align-items-center justify-content-center gap-3 mb-2"
          [ngClass]="{ 'active' : isMailingAddressDisplayed }"
          (click)="toggleMailingAddressHandler()">
          <span>{{"requests.clientData.newRequest.address.Mailing" | translate}}</span>
          <i class="app-icon icon icon-chevron-down icon-lg"></i>
        </div>
        <div class="divider-line" [hidden]="isMailingAddressDisplayed"></div>
      </div>
    </div>

    <!-- mailing address -->

    <ng-container *ngIf="isMailingAddressDisplayed">
      <div class="row justify-content-center mb-3">
        <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-center">
          <input
            kendoCheckBox
            [size]="size"
            [rounded]="rounded"
            type="checkbox"
            [(ngModel)]="isSameAddress"
            (ngModelChange)="copyAddressHandler()"
            name="checkboxCopyAddress"
            id="checkboxCopyAddress"/>
          <label for="checkboxCopyAddress"
            class="ms-2 cursor-pointer">
            {{"requests.clientData.newRequest.address.SameAsHomeAddress" | translate}}
          </label>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3">
          <label class="text-field-label">
            {{ "requests.clientData.newRequest.address.Country" | translate }}
            <span class="text-primary fw-bold">*</span>
          </label>
          <input
            kendoTextBox
            class="text-input"
            [(ngModel)]="clientDataRequestSaveModel.addresses[1].country"
            required
            name="mailingAddressCountry"
            #mailingAddressCountry="ngModel"/>
            <div class="error-info" *ngIf="mailingAddressCountry.invalid  && (mailingAddressCountry.dirty || form.submitted)">
              <div  *ngIf="mailingAddressCountry.errors?.['required']">
                {{'common.validation.required' | translate}}
              </div>
            </div>
        </div>

        <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3">
          <label class="text-field-label">
            {{ "requests.clientData.newRequest.address.State" | translate }}
            <span class="text-primary fw-bold">*</span>
          </label>
          <input
            kendoTextBox
            class="text-input"
            [(ngModel)]="clientDataRequestSaveModel.addresses[1].state"
            required
            name="mailingAddressState"
            #mailingAddressState="ngModel"/>
            <div class="error-info" *ngIf="mailingAddressState.invalid  && (mailingAddressState.dirty || form.submitted)">
              <div  *ngIf="mailingAddressState.errors?.['required']">
                {{'common.validation.required' | translate}}
              </div>
            </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3">
          <label class="text-field-label"
            >{{ "requests.clientData.newRequest.address.City" | translate }}
            <span class="text-primary fw-bold">*</span>
          </label>
          <input
            kendoTextBox
            class="text-input"
            [(ngModel)]="clientDataRequestSaveModel.addresses[1].city"
            required
            name="mailingAddressCity"
            #mailingAddressCity="ngModel"/>
            <div class="error-info" *ngIf="mailingAddressCity.invalid  && (mailingAddressCity.dirty || form.submitted)">
              <div  *ngIf="mailingAddressCity.errors?.['required']">
                  {{'common.validation.required' | translate}}
              </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3">
          <label class="text-field-label">
            {{ "requests.clientData.newRequest.address.PostalCode" | translate }}
          </label>
          <input
            kendoTextBox
            class="text-input"
            [(ngModel)]="clientDataRequestSaveModel.addresses[1].postalCode"
            name="mailingPostalCode"
          />
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-7 col-lg-6 col-xxl-5 col-xxxl-4 mb-3">
          <label class="text-field-label">{{
            "requests.clientData.newRequest.address.Street" | translate
          }}</label>
          <input
            kendoTextBox
            class="text-input"
            [(ngModel)]="clientDataRequestSaveModel.addresses[1].streetName"
            name="mailingAddressStreetName"
          />
        </div>
        <div class="col-md-5 col-lg-4 col-xxl-3 col-xxxl-2 mb-3">
          <label class="text-field-label">{{
            "requests.clientData.newRequest.address.StreetNo" | translate
          }}</label>
          <input
            kendoTextBox
            class="text-input"
            [(ngModel)]="clientDataRequestSaveModel.addresses[1].streetNumber"
            name="mailingAddressStreetNumber"
          />
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 mb-3">
          <div class="row justify-content-center">
            <div class="col-md-6 col-lg-6 col-xxl-3 col-xxxl-3">
              <label class="text-field-label">{{
                "requests.clientData.newRequest.address.BuildingNo" | translate
              }}</label>
              <input
                kendoTextBox
                class="text-input"
                [(ngModel)]="
                  clientDataRequestSaveModel.addresses[1].buildingNumber
                "
                name="mailingAddressBuildingNumber"
              />
            </div>
            <div class="col-md-6 col-lg-6 col-xxl-3 col-xxxl-3">
              <label class="text-field-label">{{
                "requests.clientData.newRequest.address.Stair" | translate
              }}</label>
              <input
                kendoTextBox
                class="text-input"
                [(ngModel)]="clientDataRequestSaveModel.addresses[1].stair"
                name="mailingAddressStair"
              />
            </div>
            <div class="col-md-6 col-lg-6 col-xxl-3 col-xxxl-3">
              <label class="text-field-label">{{
                "requests.clientData.newRequest.address.Floor" | translate
              }}</label>
              <input
                kendoTextBox
                class="text-input"
                [(ngModel)]="clientDataRequestSaveModel.addresses[1].floor"
                name="mailingAddressFloor"
              />
            </div>
            <div class="col-md-6 col-lg-6 col-xxl-3 col-xxxl-3">
              <label class="text-field-label">{{
                "requests.clientData.newRequest.address.Flat" | translate
              }}</label>
              <input
                kendoTextBox
                class="text-input"
                [(ngModel)]="clientDataRequestSaveModel.addresses[1].flatNumber"
                name="mailingAddressFlatNumber"
              />
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="row justify-content-center mt-2">
      <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
        <client-data-request-uploader
          [clientDataRequest]="clientDataRequestSaveModel"
          [deleteFileHandler]="_filesHandler.deleteFileHandler"
          [uploadFilesHandler]="_filesHandler.uploadFilesHandler">
        </client-data-request-uploader>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-5">
        <button class="btn primary-btn px-5"
          [disabled]="isSendButtonDisabled"
          type="submit"
          (click)="sendRequestCofirmationHandler()">
          <span>
            {{ 'requests.clientData.newRequest.Next' | translate}}
          </span>
        </button>
      </div>
  </form>
</div>